import type { PhoneCall } from '@salesforce/scv-connector-base';
import type { BaseUsecase } from '@usecases/base-usecase';

export type MuteAgentRequest = {
  onMute: boolean;
  call: PhoneCall;
};

export interface MuteAgentEventPublisher {
  publish(onMute: boolean, call: PhoneCall): Promise<void>;
}

export interface MuteAgentCallUsecase
  extends BaseUsecase<MuteAgentRequest, void> {
  run(req: MuteAgentRequest): Promise<void>;
}

export class MuteAgent implements MuteAgentCallUsecase {
  constructor(private publisher: MuteAgentEventPublisher) {}

  async run(req: MuteAgentRequest): Promise<void> {
    this.publisher.publish(req.onMute, req.call);
  }
}
